import React from "react";
import ReactRoundedImage from "react-rounded-image";

const Profilepic = (props) => {
    const source = props.props.Img_url;
    return <ReactRoundedImage image={source} roundedSize="0" imageWidth="40" imageHeight="40" />
};

export default Profilepic;